/**
 * Connected Services (Gmail) UI / voice gate.
 * Mirror REACT_APP_ALLOW_GUEST / REACT_APP_DEBUG: exact string equality to "true".
 * Fail-closed when unset / false / any other value.
 */

export function isConnectedServicesUiEnabled(env = process.env) {
  return env.REACT_APP_CONNECTED_SERVICES_ENABLED === "true";
}

export const CONNECTED_SERVICES_UNAVAILABLE_SPEECH =
  "Connected Services are not available in this environment.";
